export default __webpack_public_path__ + "static/media/union_design_2.a0b3c998.png";